import React from 'react';
import { SearchIcon, BellIcon, MoreHorizontalIcon, MinusIcon, CircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function HomeHeader() {
  const nav = useNavigate();
  return <div className="flex items-center gap-2 px-3 pt-3 pb-2 bg-white" data-id="element-84">
      <div className="w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-85">
        指
      </div>
      <div className="flex-1 h-9 rounded-full bg-slate-100 flex items-center px-3 gap-2" data-id="element-86">
        <SearchIcon size={14} className="text-slate-400" data-id="element-87" />
        <input aria-label="搜索" placeholder="2025录取战绩" className="bg-transparent outline-none text-sm flex-1 placeholder-slate-400" data-id="element-88" />
      </div>
      <button onClick={() => nav('/mine/notifications')} className="p-1.5 text-slate-600 relative" aria-label="消息通知" data-id="element-89">
        <BellIcon size={20} data-id="element-90" />
        <span className="absolute top-1 right-1 w-2 h-2 bg-rose-500 rounded-full border border-white" data-id="element-91" />
      </button>
      <div className="flex items-center gap-1 bg-black/5 rounded-full px-2.5 py-1.5" data-id="element-92">
        <MoreHorizontalIcon size={14} className="text-slate-700" data-id="element-93" />
        <div className="w-px h-3 bg-slate-300" data-id="element-94" />
        <MinusIcon size={12} className="text-slate-700" data-id="element-95" />
        <CircleIcon size={12} className="text-slate-700 ml-0.5" data-id="element-96" />
      </div>
    </div>;
}